import { FleetType, TrailerType } from "store/lobby/lobby-model";

export const trailerTypeList = [
  { id: TrailerType.BOX_TRAILER, description: "box_trailer" },
  { id: TrailerType.CURTAINSIDER, description: "curtainsider" },
  { id: TrailerType.FLATBED, description: "flatbed" },
  { id: TrailerType.LIGHTWEIGHT_CURTAINSIDER, description: "lightweight_curtainsider" },
  { id: TrailerType.BULK_TRAILER, description: "bulk_trailer" },
  { id: TrailerType.TANKER, description: "tanker" },
  { id: TrailerType.OTHER, description: "fleet_channel_others" },
];

export const getTrailerTypeOptions = (saleChannelId?: number | null, preserveOtherOption = false) =>
  preserveOtherOption || saleChannelId === FleetType.Others ? trailerTypeList : trailerTypeList.filter(({ id }) => id !== TrailerType.OTHER);
